import { Component, Input, ViewChild } from '@angular/core';
import { FilterField, FilterOperator, FindOptions } from '@app/models';
import { PaginatorComponent } from '../../../paginator/paginator.component';
import { SearchWidgetComponent } from '../../../search-widget/search-widget.component';
import { NotificationListComponent } from '../notification-list/notification-list.component';

@Component({
  selector: 'patron-paged-list',
  templateUrl: './paged-list.component.html',
  styleUrls: ['./paged-list.component.css'],
  standalone: false,
})
export class PagedListComponent {
  @Input() sent: boolean = false;

  isFirstPaginateCall = true;
  wasFirstSearchRan = false;
  findOptions: FindOptions = {
    perPage: 15,
    //orderBy: 'name',
    storageKey: 'notifications-find-options',
    //withs: ['modules'],
    q: '',
    filters: [
      new FilterField({
        name: 'read',
        label: 'Lido',
        type: 'radio',
        operator: FilterOperator.has,
        options: [
          { label: 'Ambos', value: '' },
          { label: 'Lido', value: '1' },
          { label: 'Não lido', value: '0' },
        ],
      }),
      new FilterField({
        name: 'date_interval',
        label: 'Data',
        type: 'betweenDates',
        operator: FilterOperator.between,
      }),
    ],
  };

  @ViewChild('paginator') paginator!: PaginatorComponent;
  @ViewChild('searchWidget') searchWidget!: SearchWidgetComponent;
  @ViewChild(NotificationListComponent) notificationList!: NotificationListComponent;

  async paginate(findOptions?: FindOptions) {
    if (this.isFirstPaginateCall) {
      this.isFirstPaginateCall = false;
      return;
    }

    if (findOptions) {
      findOptions.queryParams = { ...this.findOptions.queryParams, ...findOptions.queryParams };
      this.findOptions = { ...this.findOptions, ...findOptions };
    }

    if (this.findOptions?.q) {
      this.searchWidget.updateValue(this.findOptions.q);
    }

    this.wasFirstSearchRan = true;
    await this.notificationList.findNotifications(this.findOptions);
  }

  onSearch(searchText?: string) {
    if (searchText != this.findOptions.q) {
      this.findOptions.q = searchText;
      this.goToFirstPage();
    }
  }

  goToFirstPage() {
    this.paginate({ page: 1 });
    this.paginator.component.first = 0;
  }
}
